const BaseHostMap = {
  "me-live-websit": "h5.",
  "hiya-web": "hiya-web.",
  activity: "activity-hiya-web.",
  version: "version-hiya-web.",
  //
  static: "static.",
  "other-static": "static-hiya-web.",
  //
  img01: "img01.",
  video01: "video01.",
  api: "api."
};
const BaseHostMapComplete = (domain = "") => {
  const temp = {};
  for (const k in BaseHostMap) {
    temp[k] = BaseHostMap[k] + domain;
  }
  return temp;
};
export {
  BaseHostMap,
  BaseHostMapComplete
};
